import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FareAndRatesDetailsDailogComponent } from './fare-and-rates-details-dialog.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule],
  exports: [FareAndRatesDetailsDailogComponent],
  declarations: [FareAndRatesDetailsDailogComponent]
})
export class FareAndRatesDetailsDailogModule {}
